import { TooltipIcon } from '@ipfabric/ui-components/Tooltip/TooltipIcon';
import type { ViptelaDataErrorHandlingSettings } from '@ipfabric/utils';
import {
  unreachableDeviceBaseDelaySec,
  unreachableDeviceMaxRetry,
} from '@ipfabric/utils/settings/vendorApi/defaults/viptela';
import { FormikTextField } from 'components/FormikTextField/FormikTextField';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';

interface Props<T extends ViptelaDataErrorHandlingSettings> {
  formik: FormikProps<T>;
}

export const FormikViptelaDataErrorHandlingSettingsFields = <
  T extends ViptelaDataErrorHandlingSettings,
>(
  props: Props<T>,
): JSX.Element => {
  return (
    <>
      <hr className='mt-0' />

      <div className='mb-3.5 font-semibold !text-black'>
        Request retry for unreachable Viptela devices
      </div>
      <div className='flex gap-3'>
        <div className='flex items-center gap-2'>
          <FormikTextField
            formik={props.formik}
            label='maxRetry count'
            name='unreachableDeviceMaxRetry'
            type='number'
            className='w-24'
            {...unreachableDeviceMaxRetry.boundaryValues}
          />
          <div className='w-20' />
        </div>
        <div className='flex items-center gap-2'>
          <FormikTextField
            formik={props.formik}
            label={
              <>
                Delay
                <TooltipIcon
                  content='The time interval between attempts will be calculated as (the attempt number - 1) * delay'
                  iconProps={{
                    iconStyle: 'solid',
                    inline: true,
                  }}
                  className='ml-2'
                  size='sm'
                />
              </>
            }
            name='unreachableDeviceBaseDelaySec'
            type='number'
            className='w-24'
            {...unreachableDeviceBaseDelaySec.boundaryValues}
          />
          <span className='font-semibold'>seconds</span>
        </div>
      </div>
    </>
  );
};
